export default {
    "hell": require("./hell").default,
    "ember": require("./ember").default,
    "pirates": require("./pirates").default,
    "dungeon": require("./dungeon").default,
}
